import { Form, FormActions, Modal, PhoneInput, message } from 'ui';
import { useProgramChangeRequestMutation } from '../queries/mutations';

export type ContactUsFormValues = {
  invitationPhone: string;
};

type P = {
  onSuccess: (programId: string) => void;
  programId: string;
  userPhone?: string;
};

const ContactUsForm = ({ onSuccess, programId, userPhone }: P) => {
  const [form] = Form.useForm<ContactUsFormValues>();
  const { isPending: isLoading, mutate: programChangeRequest } = useProgramChangeRequestMutation();

  const onFinish = (data: ContactUsFormValues) => {
    programChangeRequest(
      { data, programId },
      {
        onError() {
          message.error('Failed to request contact');
        },
        onSuccess() {
          message.success('Requests are generally reviewed withing 24 hours');
          onSuccess(programId);
        },
      },
    );
  };

  return (
    <Form<ContactUsFormValues> form={form} initialValues={{ invitationPhone: userPhone }} onFinish={onFinish}>
      <PhoneInput
        input={{
          placeholder: '123 456 7890',
        }}
        item={{
          label: 'Your phone number',
          name: 'invitationPhone',
          rules: [
            {
              required: true,
            },
          ],
        }}
      />
      <Modal.HugContent.Footer>
        <FormActions
          submit={{
            children: 'Send request',
            loading: isLoading,
          }}
        />
      </Modal.HugContent.Footer>
    </Form>
  );
};

export default ContactUsForm;
